module.exports = __webpack_public_path__ + "static/media/Audiowide.e9ee108c.ttf";